import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useJWTAuth } from "../context/JWTAuthContext";
import "./LoginPage.css";

const LoginPage = ({ onLoginSuccess, onSignupClick }) => {
  const { login } = useJWTAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    userId: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // 입력값 변경 핸들러
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 에러 메시지 클리어
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  // 폼 제출 핸들러
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!formData.userId.trim()) {
      setErrorMessage("아이디를 입력해주세요.");
      return;
    }

    if (!formData.password.trim()) {
      setErrorMessage("비밀번호를 입력해주세요.");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");

    try {
      // 로그인 시도
      console.log('📝 [LoginPage] 로그인 시도:', {
        userId: formData.userId.trim(),
        hasPassword: !!formData.password
      });

      const result = await login(formData.userId.trim(), formData.password);

      console.log('📨 [LoginPage] 로그인 결과:', result);

      if (result.success) {
        // 로그인 성공 - 게시판 페이지로 이동
        console.log('🎉 로그인 성공, 게시판 페이지로 이동');
        navigate('/board/free');
        
        // 기존 콜백도 호출
        if (onLoginSuccess) {
          onLoginSuccess(result.user);
        }
      } else {
        // 로그인 실패
        setErrorMessage(result.message);
      }
    } catch (error) {
      console.error("로그인 처리 중 오류:", error);
      setErrorMessage("시스템 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">J's Planner</h1>
          <p className="login-subtitle">로그인하여 시작하세요</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {errorMessage}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="userId" className="form-label">
              아이디
            </label>
            <input
              type="text"
              id="userId"
              name="userId"
              value={formData.userId}
              onChange={handleInputChange}
              className="form-input"
              placeholder="아이디를 입력하세요"
              disabled={isLoading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              비밀번호
            </label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className="form-input"
                placeholder="비밀번호를 입력하세요"
                disabled={isLoading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                aria-label={showPassword ? "비밀번호 숨기기" : "비밀번호 보기"}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className={`login-button ${isLoading ? "loading" : ""}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading-text">로그인 중...</span>
            ) : (
              "로그인"
            )}
          </button>
        </form>

        <div className="login-actions">
          <p className="signup-text">계정이 없으신가요?</p>
          <button
            type="button"
            className="signup-button"
            onClick={() => navigate('/signup')}
            disabled={isLoading}
          >
            <span className="signup-icon">✏️</span>
            회원가입
          </button>
        </div>

        <div className="login-footer">
          <p className="footer-text">React 기반 여행 계획 및 일정 관리 도구</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
